<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  /*min-height: calc(/100vh - 50px);*/
  width: 100%;
  position: relative;
  flex-grow: 1; 
  /* overflow-y: hidden; */

}
.fixed-header+.app-main {
  padding-top: .63rem;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: .19rem;
  }
}
</style>
